/* eslint-disable boundaries/dependencies */
import { memo } from 'react'
import { Routes, Route } from 'react-router-dom'

import {
  PrivacyPage,
  FaqPage,
  // AboutUsPage,
  GeneralTermsPage,
  // PricingPage,
} from '@pages/default'
import MealPage from '@pages/meal'
import StatsPage from '@pages/stats'

const FCUserRouter = () => {
  return (
    <Routes>
      {/* ************************************************************************** */}

      <Route path="meal/:mealId" element={<MealPage />} />

      <Route path="stats" element={<StatsPage />} />

      {/* <Route path="pricing" element={<PricingPage />} /> */}

      {/* <Route path="about-us" element={<AboutUsPage />} /> */}
      <Route path="faq" element={<FaqPage />} />

      {/* ************************************************************************** */}

      <Route path="privacy" element={<PrivacyPage />} />
      <Route path="terms" element={<GeneralTermsPage />} />

      {/* ************************************************************************** */}
    </Routes>
  )
}
export const UserRouter = memo(FCUserRouter)
